import React, { Component } from "react";
import { connect } from "react-redux";

class LogoLogin extends Component<{ className: string; logo: string }> {
    render() {
        return <img src={this.props.logo} className={this.props.className} alt="Seismic logo" />;
    }
}

const mapStateToProps = state => ({ logo: state.utils.logoLogin });

export default connect(mapStateToProps)(LogoLogin);